<template>
  <div>
    <div class="col-xs-12 noPadding slideMenu">
      <sub-menu-bar :pcSubPageMenu="pcSubPageMenu" @subpagemenu="subpagemenu"></sub-menu-bar>
    </div>
   <div class="row otherWrap">
      <div class="container">
        <div class="col-xs-12 col-sm-6 col-md-6">
          <div class="page-header-news clearfix">
            <img class="icon1" src="../../static/images/aboutcifi/a-icon1.png"/><span>宣传片</span>
          </div>
          <div class="page-pic">
            <video-player  class="video-player vjs-custom-skin"
              ref="videoPlayer"
              :playsinline="true"
              :options="playerOptions">
            </video-player>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-6">
          <div class="page-header-news clearfix">
            <img class="icon1" src="../../static/images/aboutcifi/a-icon2.png"/><span>简介</span>
            <router-link :to="{name: 'IntroPage', query: {name: '投洽会简介'}}" class="more right">更多</router-link>
          </div>
          <div class="row page-info">
            <div v-html="content" style="height: 150px;overflow: hidden;"></div>
          </div>
          <div class="page-header-news clearfix" style="margin-top: 0px;">
            <img class="icon1" src="../../static/images/aboutcifi/a-icon3.png"/><span>关于投洽会</span>
          </div>
          <div class="row page-list">
            <p class="col-xs-6 col-sm-4 col-md-4" v-for="(item,idx) in aboutCifi" :key="idx" @click="jump(item)"><v-clamp autoresize :max-lines="2">{{item.title}}</v-clamp></p>
          </div>
        </div>
      </div>
    </div>
    <div class="row picWrap">
      <div class="container">
        <div class="col-xs-12 col-sm-12 col-md-12">
          <!-- 领导寄语 -->
          <div class="page-header-news clearfix">
            <img class="icon1" src="../../static/images/aboutcifi/a-icon4.png"/><span>领导寄语</span>
            <router-link :to="{name: 'MsgPage', query: {name: '领导寄语'}}" class="more right">更多</router-link>
          </div>
          <div class="row msgWrap">
            <div class="col-xs-12 col-sm-6 col-md-6 page-msg" v-for="(litem, lidx) in loaderList" :key="lidx">
              <div class="col-xs-4 col-sm-3 col-md-3 page-img">
                <div class="page-img-main">
                  <img :src="globalVar.imgUrl + litem.imageUrl"/>
                </div>
              </div>
              <div class="col-xs-8 col-sm-9 col-md-9 page-main">
                <p><v-clamp autoresize :max-lines="2">{{litem.remarks}}</v-clamp></p>
                <h3>——{{litem.firstPosition}}</h3>
                <h4>{{litem.secondPosition}}</h4>
                <h4>{{litem.thirdPosition}}</h4>
                <h4>{{litem.leaderName}}</h4>
              </div>
            </div>
          </div>
          <!-- 五大洲的声音 -->
          <div class="page-header-news clearfix">
            <img class="icon1" src="../../static/images/aboutcifi/a-icon5.png"/><span>五大洲的声音</span>
            <router-link :to="{name: 'VoicePage', query: {name: '五大洲的声音'}}" class="more right">更多</router-link>
          </div>
          <div class="row msgWrap">
            <div class="col-xs-12 col-sm-6 col-md-6 page-msg" v-for="(litem, lidx) in voiceList" :key="lidx">
              <div class="col-xs-4 col-sm-3 col-md-3 page-img">
                <div class="page-img-main">
                  <img :src="globalVar.imgUrl + litem.imageUrl"/>
                </div>
              </div>
              <div class="col-xs-8 col-sm-9 col-md-9 page-main">
                <p><v-clamp autoresize :max-lines="2">{{litem.remarks}}</v-clamp></p>
                <h3>——{{litem.firstPosition}}</h3>
                <h4>{{litem.secondPosition}}</h4>
                <h4>{{litem.leaderName}}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import subMenuBar from '@/components/subMenuBar/subMenuBar'
import VClamp from 'vue-clamp'
export default {
  components: {
    subMenuBar,
    VClamp
  },
  data () {
    return {
      pcSubPageMenu: this.globalmenu.cifi,
      playerOptions: {
        // playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '4:3', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
        type: "video/mp4",
        src: "https://www.chinafair.org.cn/cifit/flash/第21届中国国际投资贸易洽谈会 30秒20210812092332.mp4" //你的视频地址（必填）
        }],
        poster: "", //你的封面地址
        width: document.documentElement.clientWidth,
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
            timeDivider: true,
            durationDisplay: true,
            remainingTimeDisplay: false,
            fullscreenToggle: true  //全屏按钮
        }
      },
      aboutCifi: [
        {
          title: '投洽会简介',
          pathName: 'IntroPage',
          name: '投洽会简介'
        },{
          title: '会标释义',
          pathName: 'LogoPage',
          name: '会标释义'
        },{
          title: '领导寄语',
          pathName: 'MsgPage',
          name: '领导寄语'
        },{
          title: '组织机构',
          pathName: 'ORGPage',
          name: '组织机构'
        },{
          title: '组委会领导',
          pathName: 'LeaderPage',
          name: '组委会领导'
        },{
          title: '五大洲的声音',
          pathName: 'VoicePage',
          name: '五大洲的声音'
        },{
          title: '主题',
          pathName: 'ThemePage',
          name: '主题、形式'
        },{
          title: '形式',
          pathName: 'ThemePage',
          name: '主题、形式'
        },{
          title: '功能',
          pathName: 'FuncPage',
          name: '功能'
        },{
          title: '历届精彩回顾',
          pathName: 'HisMPage',
          name: '历届回顾'
        },{
          title: '举办地厦门',
          pathName: 'XMPage',
          name: '迷人的厦门'
        },{
          title: '联络组委会',
          pathName: 'contactAPage',
          name: '联络组委会'
        }
      ],
      loader: Array,
      voice: Array,
      video: Array,
      content: '',
    }
  },
  async created(){
    await this.init();
  },
  computed: {
    loaderList: function () {
      return this.loader.slice(0, 4)
    },
    voiceList: function () {
      return this.voice.slice(0, 4)
    }
  },
  methods: {
    subpagemenu(item){
      this.$router.push({
        name: item.pathName,
        query: {
          name: item.subName,
        }
      })
    },
    jump(item){
      this.$router.push({
        name: item.pathName,
        query: {
          name: item.name,
        }
      })
    },
    async init(){
      this.introduction();
      this.loader = await this.getData(1);//1：领导寄语
      this.voice = await this.getData(2);//2：五大洲的声音
      let vdata = await this.mainVideo(2);// 2：关于投洽会宣传视频
      this.video = vdata[0];
      this.playerOptions.sources[0].src = this.globalVar.imgUrl+this.video.fileurl;
      this.playerOptions.poster = this.globalVar.imgUrl+this.video.coverurl;
    },
    async introduction(){
      let params = {
        language: this.globalVar.lang
      }
      let data = await this.$store.dispatch("introduction", params);
      this.content = data.content;
    },
    async getData(type){
      let params = {
        type,
        language: this.globalVar.lang
      }
      return await this.$store.dispatch("findByType", params);
    },
    mainVideo(type){
      let params = {
        counts: '',
        type,
        language: this.globalVar.lang
      }
      return this.$store.dispatch("mainVideo", params);
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import '../../static/function.less';
.otherWrap{
  margin-bottom: 3%;
  .page-header-news{
    margin-top: 3%;
  }
  .page-pic{
    padding: 3%;
    text-align: center;
    cursor: pointer;
  }
  .page-info{
    font-size: @font14;
    line-height: 28px;
    padding: 3%;
    text-align: justify;
  }
  .page-list{
    margin-top: 5%;
    padding: 0 3%;
    cursor: pointer;
    p{
      font-size: @font14;
      height: 42px;
      line-height: 20px;
      color: #303133;
      position: relative;
      &:hover{
        .hoverTxtColor()
      }
      &:before{
        content:''; 
        position: absolute;
        left: 0;
        top: 6px;
        display: inline-block;
        width: 10px;
        height: 10px;
        border: 1px solid #ccc;
        border-radius: 50%;
      }
    }
  }
}
.picWrap{
  margin-bottom: 3%;
  .msgWrap{
    margin-bottom: 3%;
    .flexitems(flex-start);
    .page-msg{
      .flexitems(center);
      font-size: @font14;
      margin-top: 2%;
      padding: 0;
      .page-img{
        .page-img-main{
          margin: 0 auto;
        }
      }
      .page-main{
        padding: 0px;
        h3,h4{
          font-size: @font14;
          padding-left: 2%;
          font-weight: bold;
          margin-top: 2%; 
        }
      }
    }
  }
}

.slideMenu{
  display: none;
}
@media (min-width: 320px) and (max-width: 767px){
    .slideMenu{
        display: block;
    }
    .page-img{
      // padding-left: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/AboutCifi.vue